import request from "../utils/request-axios";
import api from "../utils/api";


//系统用户列表
export function getUserPage(params) {
  return request(`${api.getUserPage}`, {
    loading: true,
    method: 'get',
    data: params,
  })
}

//启用
export function getUserStart(params) {
  return request(`${api.getUserStart}${params}`, {
    loading: true,
    method: 'put',
  });
}

//停用
export function getUserStop(params) {
  return request(`${api.getUserStop}${params}`, {
    loading: true,
    method: 'put',
  })
}

//解除关联
export function getUserRelieve(params) {
  return request(`${api.getUserRelieve}${params}`, {
    loading: true,
    method: 'delete',
  })
}

//修改平台权限
export function updateUserPlatform(params) {
  return request(`${api.updateUserPlatform}`, {
    loading: true,
    method: 'put',
    data: params
  })
}

//todo 获取用户详情
export function getUserDetails(params) {
  return request(`${api.getUserDetails}${params}`, {
    loading: true,
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/services/systemUaer.js